import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

export const getDefaultState = () => {
    return {
        error: null,
        loading: false,
        data: {
            code: code,
            codeAPI: codeAPI,
            module: {},
            panels: {
                home: {
                    menu: {
                        route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                        text: 'home.title',
                        icon: 'fas fa-home',
                    },
                    acl: {
                        view: 'MB_00006',
                    },
                },
                settings: {
                    menu: {
                        route: `${code}.settings`,
                        text: 'settings.titles',
                        icon: 'fas fa-cogs',
                    },
                    acl: {
                        view                    : 'MB_00620',
                        edit                    : 'MB_00621',
                    },
                    url: {
                        getConfig               : `/${codeAPI}/gestao/definitions`,
                    },
                },
                default_layers: {
                    menu: {
                        route: `${code}.default_layers`,
                        text: 'default_layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'MB_00646',
                        detail                  : 'MB_00647',
                        add                     : 'MB_00648',
                        edit                    : 'MB_00649',
                        delete                  : 'MB_00650',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/defaultlayers`,
                        getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                        getCreate               : `${codeAPI}/gestao/defaultlayers`,
                        getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                        getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                        getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                        getResources            : `${codeAPI}/gestao/defaultlayers/resources`,
                    },
                },
                layers: {
                    menu: {
                        route: `${code}.layers`,
                        text: 'layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'MB_00548',
                        detail                  : 'MB_00549',
                        add                     : 'MB_00551',
                        edit                    : 'MB_00552',
                        delete                  : 'MB_00550',
                        private                 : 'MB_00553',
                    },
                    url: {
                        getList: `${codeAPI}/gestao/layers`,
                        getShow: `${codeAPI}/gestao/layers/:id`,
                        getCreate: `${codeAPI}/gestao/layers`,
                        getUpdate: `${codeAPI}/gestao/layers/:id`,
                        getDelete: `${codeAPI}/gestao/layers/:id`,
                        getLists: `${codeAPI}/gestao/layers/lists`,
                        getResources: `${codeAPI}/gestao/layers/resources`,
                        describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                    },
                },
                regulations: {
                    menu: {
                        route: `${code}.regulations`,
                        text: `regulations.titles`,
                        icon: "fas fa-book"
                    },
                    panel: {
                        files: {
                            maxFiles: 1,
                            mimeTypes: [
                                "application/msword",
                                "application/vnd.ms-excel",
                                "application/vnd.ms-powerpoint",
                                "application/pdf",
                                "text/plain",
                                "image/*",
                            ],
                        }
                    },
                    acl: {
                        view: "MB_00662",
                        detail: "MB_00663",
                        add: "MB_00664",
                        edit: "MB_00665",
                        delete: "MB_00666"
                    },
                    url: {
                        getList: `${codeAPI}/gestao/regulations`,
                        getShow: `${codeAPI}/gestao/regulations/:id`,
                        getCreate: `${codeAPI}/gestao/regulations`,
                        getUpdate: `${codeAPI}/gestao/regulations/:id`,
                        getDelete: `${codeAPI}/gestao/regulations/:id`,
                        getLists: `${codeAPI}/gestao/regulations/lists`
                    }
                },
                print_visible_emissions: {
                    menu: {
                        route: `${code}.print_visible_emissions.config`,
                        text: "print_visible_emissions.title",
                        icon: "fas fa-print",
                    },
                    acl: {
                        view: "MB_00644",
                        config: "MB_00644",
                        configEdit: "MB_00645",
                    },
                    url: {
                        getList: `/${codeAPI}/gestao/printvisible`,
                        getConfig: `/${codeAPI}/gestao/printvisible/settings`,
                        getApps: `/${codeAPI}/gestao/printvisible/print/apps`,
                    },
                },
                channels: {
                    menu: {
                        route: `${code}.channels`,
                        text: 'channels.titles',
                        icon: 'fas fa-keyboard',
                    },
                    acl: {
                        view                    : 'MB_00042',
                        detail                  : 'MB_00043',
                        add                     : 'MB_00045',
                        edit                    : 'MB_00046',
                        delete                  : 'MB_00044',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/channels`,
                        getShow                 : `${codeAPI}/gestao/channels/:id`,
                        getCreate               : `${codeAPI}/gestao/channels`,
                        getUpdate               : `${codeAPI}/gestao/channels/:id`,
                        getDelete               : `${codeAPI}/gestao/channels/:id`,
                    },
                },
                notifications: {
                    menu: {
                        route: `${code}.notifications`,
                        text: 'notifications.titles',
                        icon: 'fas fa-envelope',
                    },
                    acl: {
                        view                    : 'MB_00369',
                        detail                  : 'MB_00370',
                        add                     : 'MB_00373',
                        edit                    : 'MB_00371',
                        delete                  : 'MB_00372',
                        config                  : 'MB_00651',
                        configEdit              : 'MB_00652',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/notifications`,
                        getShow                 : `${codeAPI}/gestao/notifications/:id`,
                        getCreate               : `${codeAPI}/gestao/notifications`,
                        getUpdate               : `${codeAPI}/gestao/notifications/:id`,
                        getDelete               : `${codeAPI}/gestao/notifications/:id`,
                        getLists                : `${codeAPI}/gestao/notifications/lists`,
                        getConfigLists          : `${codeAPI}/gestao/notifications/settings/lists`,
                        getConfig               : `${codeAPI}/gestao/notifications/settings`,
                    },
                },
                priorities: {
                    menu: {
                        route: `${code}.priorities`,
                        text: 'priorities.titles',
                        icon: 'fas fa-wave-square',
                    },
                    acl: {
                        view                    : 'MB_00027',
                        detail                  : 'MB_00028',
                        add                     : 'MB_00030',
                        edit                    : 'MB_00031',
                        delete                  : 'MB_00029',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/priorities`,
                        getShow                 : `${codeAPI}/gestao/priorities/:id`,
                        getCreate               : `${codeAPI}/gestao/priorities`,
                        getUpdate               : `${codeAPI}/gestao/priorities/:id`,
                        getDelete               : `${codeAPI}/gestao/priorities/:id`,
                    },
                },
                statuses: {
                    menu: {
                        route: `${code}.statuses`,
                        text: 'statuses.titles',
                        icon: 'fas fa-info-circle',
                    },
                    acl: {
                        view                    : 'MB_00057',
                        detail                  : 'MB_00058',
                        add                     : 'MB_00050',
                        edit                    : 'MB_00051',
                        delete                  : 'MB_00059',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/statuses`,
                        getShow                 : `${codeAPI}/gestao/statuses/:id`,
                        getCreate               : `${codeAPI}/gestao/statuses`,
                        getUpdate               : `${codeAPI}/gestao/statuses/:id`,
                        getDelete               : `${codeAPI}/gestao/statuses/:id`,
                        getTransform            : `${codeAPI}/gestao/statuses/transform`,
                    }
                },
                types: {
                    menu: {
                        route: `${code}.types`,
                        text: 'types.titles',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'MB_00032',
                        detail                  : 'MB_00033',
                        add                     : 'MB_00035',
                        edit                    : 'MB_00036',
                        delete                  : 'MB_00034',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/types`,
                        getShow                 : `${codeAPI}/gestao/types/:id`,
                        getCreate               : `${codeAPI}/gestao/types`,
                        getUpdate               : `${codeAPI}/gestao/types/:id`,
                        getDelete               : `${codeAPI}/gestao/types/:id`,
                    },
                },
                subtypes: {
                    menu: {
                        route: `${code}.subtypes`,
                        text: 'subtypes.titles',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'MB_00037',
                        detail                  : 'MB_00038',
                        add                     : 'MB_00040',
                        edit                    : 'MB_00041',
                        delete                  : 'MB_00039',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/subtypes`,
                        getShow                 : `${codeAPI}/gestao/subtypes/:id`,
                        getCreate               : `${codeAPI}/gestao/subtypes`,
                        getUpdate               : `${codeAPI}/gestao/subtypes/:id`,
                        getDelete               : `${codeAPI}/gestao/subtypes/:id`,
                        getTypes                : `${codeAPI}/gestao/subtypes/types`,
                    },
                },
                unities: {
                    menu: {
                        route: `${code}.unities`,
                        text: 'unities.titles',
                        icon: 'fas fa-stream',
                    },
                    acl: {
                        view                    : 'MB_00022',
                        detail                  : 'MB_00023',
                        add                     : 'MB_00025',
                        edit                    : 'MB_00026',
                        delete                  : 'MB_00024',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/unities`,
                        getShow                 : `${codeAPI}/gestao/unities/:id`,
                        getCreate               : `${codeAPI}/gestao/unities`,
                        getUpdate               : `${codeAPI}/gestao/unities/:id`,
                        getDelete               : `${codeAPI}/gestao/unities/:id`,
                        getTypes                : `${codeAPI}/gestao/unities/types`,
                        getUsers                : `${codeAPI}/gestao/unities/search/user`,
                    },
                },
                reminders: {
                    menu: {
                        route: `${code}.reminders`,
                        text: 'reminders.titles',
                        icon: 'fas fa-stream',
                    },
                    acl: {
                        view                    : 'MB_00653',
                        detail                  : 'MB_00654',
                        add                     : 'MB_00655',
                        edit                    : 'MB_00656',
                        delete                  : 'MB_00657',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/reminders`,
                        getShow                 : `${codeAPI}/gestao/reminders/:id`,
                        getCreate               : `${codeAPI}/gestao/reminders`,
                        getUpdate               : `${codeAPI}/gestao/reminders/:id`,
                        getDelete               : `${codeAPI}/gestao/reminders/:id`,
                        getLists                : `${codeAPI}/gestao/reminders/lists/:id`,
                    },
                },
                edoclink_maps: {
                    active: false,
                    menu: {
                        route: `${code}.edoclink_maps`,
                        text: 'edoclink_maps.titles',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'MB_00629',
                        detail                  : 'MB_00623',
                        add                     : 'MB_00624',
                        edit                    : 'MB_00625',
                        delete                  : 'MB_00626',
                        config                  : 'MB_00627',
                        configEdit              : 'MB_00628',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/edoclinkmaps`,
                        getShow                 : `/${codeAPI}/gestao/edoclinkmaps/:id`,
                        getCreate               : `/${codeAPI}/gestao/edoclinkmaps`,
                        getUpdate               : `/${codeAPI}/gestao/edoclinkmaps/:id`,
                        getDelete               : `/${codeAPI}/gestao/edoclinkmaps/:id`,

                        getConfig               : `/${codeAPI}/gestao/edoclinkmaps/settings`,
                        getScales               : `/${codeAPI}/gestao/edoclinkmaps/scales`,
                        getLayouts              : `/${codeAPI}/gestao/edoclinkmaps/print/layouts/:appid`,
                        getFormats              : `/${codeAPI}/gestao/edoclinkmaps/print/formats/:appid`,
                        getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                    },
                },
            },
            tools: {

            },
        },
    };
};

const state = getDefaultState();

export default state;